import { render } from "./SnatTicketButton.vue?vue&type=template&id=83aedd5a&scoped=true"
import script from "./SnatTicketButton.vue?vue&type=script&lang=js"
export * from "./SnatTicketButton.vue?vue&type=script&lang=js"

import "./SnatTicketButton.vue?vue&type=style&index=0&id=83aedd5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83aedd5a"]])

export default __exports__